import styled from '@emotion/styled'

const SkeletonContainer = styled.div`
    width: 100%;
    height: 100%;
    padding: 24px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`

const SkeletonHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e5e7eb;
`

const SkeletonIcon = styled.div`
    width: 40px;
    height: 40px;
    background: #f3f4f6;
    border-radius: 8px;
    animation: pulse 1.5s ease-in-out infinite;
`

const SkeletonTitle = styled.div`
    width: 150px;
    height: 24px;
    background: #f3f4f6;
    border-radius: 4px;
    animation: pulse 1.5s ease-in-out infinite;
`

const SkeletonContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`

const SkeletonItem = styled.div<{ width?: string; height?: string }>`
    width: ${({ width }) => width || '100%'};
    height: ${({ height }) => height || '40px'};
    background: #f3f4f6;
    border-radius: 4px;
    animation: pulse 1.5s ease-in-out infinite;
`

interface SkeletonLoaderProps {
    showHeader?: boolean
    itemCount?: number
    itemWidth?: string
    itemHeight?: string
}

const SkeletonLoader = ({
    showHeader = true,
    itemCount = 3,
    itemWidth = '100%',
    itemHeight = '40px',
}: SkeletonLoaderProps) => {
    return (
        <>
            <style>
                {`
                    @keyframes pulse {
                        0%, 100% {
                            opacity: 1;
                        }
                        50% {
                            opacity: 0.5;
                        }
                    }
                `}
            </style>
            <SkeletonContainer>
                {showHeader && (
                    <SkeletonHeader>
                        <SkeletonIcon />
                        <SkeletonTitle />
                    </SkeletonHeader>
                )}
                <SkeletonContent>
                    {Array.from({ length: itemCount }).map((_, index) => (
                        <SkeletonItem key={index} width={itemWidth} height={itemHeight} />
                    ))}
                </SkeletonContent>
            </SkeletonContainer>
        </>
    )
}

export default SkeletonLoader
